import { render, staticRenderFns } from "./DispensaryItemCost.vue?vue&type=template&id=7ca12095"
import script from "./DispensaryItemCost.vue?vue&type=script&lang=ts"
export * from "./DispensaryItemCost.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports